import PortfolioExplorer from './index'

const portfolioExplorerComponents = {
  PortfolioExplorer
}

export default portfolioExplorerComponents
